<template>
  <div class="lock-gate-input">
    <BField
      label="Do you lock your gate?"
      class="lock-gate-input--radios"
      :type="{ 'is-error': isInvalid }"
      :message="isInvalid ? 'This is required' : ''"
    >
      <section>
        <div class="field">
          <BRadio
            v-model="selectedRadio"
            label="Do you lock your gate?"
            native-value="key"
            test-id="with_key"
            @input="onRadioClick"
          >
            Yes, with a gate key
          </BRadio>
        </div>
        <div class="field">
          <BRadio
            v-model="selectedRadio"
            native-value="code"
            test-id="code"
            class="lock-gate-input--code-div"
            @input="onRadioClick"
          >
            Yes, with a gate code
            <div
              v-if="screenSize.desktop && selectedRadio === 'code'"
              class="lock-gate-input--line"
            />
          </BRadio>
        </div>
        <BCollapse :open="!screenSize.desktop && selectedRadio === 'code'">
          <LsInput
            v-model="localCode"
            label="What is the access code?"
            test-id="code_input"
            name="lock_gate_input-code"
            :track-id="trackId"
            class="lock-gate-input--input-wrapper"
            @input.native="onCodeInput"
          />
        </BCollapse>
        <div class="field">
          <BRadio v-model="selectedRadio" native-value="no" test-id="false" @input="onRadioClick">
            No
          </BRadio>
        </div>
      </section>
    </BField>
    <BCollapse :open="screenSize.desktop && selectedRadio === 'code'">
      <LsInput
        v-model="localCode"
        label="What is the access code?"
        test-id="code_input"
        name="lock_gate_input-code"
        :track-id="trackId"
        class="lock-gate-input--input-wrapper"
        @input.native="onCodeInput"
      />
    </BCollapse>
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import { LsInput } from '@/components/common';
import { mapState } from 'vuex';
import { lsPropTypeHelpers, lsTrackingService } from 'ls-vue-common';
import _ from 'lodash';

export default {
  name: 'LockGateInput',
  components: { LsInput },
  props: {
    value: VueTypes.any.isRequired,
    trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
    formDirty: VueTypes.bool.def(false),
  },
  data() {
    return {
      localValue: this.value,
      localCode: '',
      selectedRadio: null,
    };
  },
  computed: {
    ...mapState(['screenSize']),
    isInvalid() {
      return (
        this.formDirty &&
        (_.isNull(this.selectedRadio) || (this.selectedRadio === 'code' && this.localCode === ''))
      );
    },
  },
  watch: {
    value(newValue) {
      this.updateSelected(newValue);
    },
  },
  created() {
    this.updateSelected(this.value);
  },
  methods: {
    updateSelected(value) {
      if (!_.isNull(value)) {
        this.localValue = value;
        if (this.localValue === 'Locked w/ key') {
          this.selectedRadio = 'key';
        } else if (_.isString(this.localValue) && _.size(this.localValue) > 0) {
          this.localCode = this.localValue;
          this.selectedRadio = 'code';
        } else if (this.localValue === false) {
          this.selectedRadio = 'no';
        }
      } else {
        this.localValue = null;
        this.localCode = '';
        this.selectedRadio = null;
      }
    },
    onRadioClick(value) {
      lsTrackingService.track({
        event: 'click',
        target: this.trackId,
        data: { value },
      });

      // clear code when clicking other radios
      if (value !== 'code') {
        this.localCode = '';
      }

      this.$emit('input', {
        locked: value === 'key' || value === 'code',
        code: value === 'key' ? 'Locked w/ key' : this.localCode,
      });
    },
    onCodeInput() {
      this.$emit('input', {
        locked: true,
        code: this.localCode,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.lock-gate-input {
  display: flex;
  align-items: center;
}

.lock-gate-input--radios {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.lock-gate-input--line {
  position: absolute;
  right: -16px;
  top: 11px;
  height: 1px;
  width: 12px;
  background-color: $primary;
}

.lock-gate-input--input-wrapper {
  padding: 0px 0 8px 20px;
}

@media (max-width: $mobile-max-width) {
  .lock-gate-input--input-wrapper {
    padding: 0px 0 15px 0;
  }
}

.themed-app {
  .lock-gate-input--line {
    background-color: $theme-color-primary;
  }
}
</style>
